import React from 'react'
import { translate } from 'react-i18next'

import DelayLink from '../../Global/DelayLink'
import scrollIt from '../../../utils/scrollIt'

export default translate('common')(({ currentStep, slug, t }) => (
  <DelayLink
    to={{
      pathname: `/${slug}/${currentStep + 1}`,
      state: {
        to: 'trip'
      }
    }}
    delay={700}
    className="trip__next-step button button--outline button--round"
    onClick={() => scrollIt(0, 700, 'easeInOutQuint')}
  >
    { t('step-next.button') }
  </DelayLink>
))


// WEBPACK FOOTER //
// ./src/components/Step/StepNext/StepNext.js